/**
 * Payment helper utilities for managing Dojo payment intents
 */

/**
 * Voids a Dojo payment intent and cleans up storage
 * @param {string} paymentIntentId - The payment intent ID to void
 * @param {string} logPrefix - Optional prefix for console logs
 */
export const voidPaymentIntentSync = (paymentIntentId, logPrefix = '') => {
    if (!paymentIntentId) return;
    
    console.log(`${logPrefix}Voiding payment intent:`, paymentIntentId);
    
    // Use fetch with keepalive for guaranteed delivery even during navigation
    // credentials: 'include' ensures cookies (JWT session) are sent with the request
    fetch(`/api/dojoPayment/void/${paymentIntentId}`, {
        method: 'POST',
        keepalive: true,
        credentials: 'include',  // Send cookies (JWT session token) with request
        headers: { 
            'Content-Type': 'application/json'
        }
    }).catch(err => console.error(`${logPrefix}Failed to void payment intent:`, err));
    
    // Clean up storage
    window.sessionStorage.removeItem('currentPaymentIntentId');
};

/**
 * Gets the current payment intent ID from sessionStorage
 * @returns {string|null} The payment intent ID or null
 */
export const getCurrentPaymentIntentId = () => {
    return window.sessionStorage.getItem('currentPaymentIntentId');
};
